var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDebitDirection = function SvgDebitDirection(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.9C0 4.8801 4.8801 0 10.9 0C16.9199 0 21.8 4.8801 21.8 10.9C21.8 16.9199 16.9199 21.8 10.9 21.8C4.8801 21.8 0 16.9199 0 10.9ZM10.9 1.8C5.87421 1.8 1.8 5.87421 1.8 10.9C1.8 15.9258 5.87421 20 10.9 20C15.9258 20 20 15.9258 20 10.9C20 5.87421 15.9258 1.8 10.9 1.8ZM6 10.9C6 10.4029 6.40294 10 6.9 10H14.9C15.3971 10 15.8 10.4029 15.8 10.9C15.8 11.3971 15.3971 11.8 14.9 11.8H6.9C6.40294 11.8 6 11.3971 6 10.9Z",
    fill: "#D80E25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDebitDirection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "debit-direction.94d58254ab871a51bf0ac5094cc82085.svg";